import { useRMSelector } from 'redux/hooks';

export const useLayerDesignSelectedTabIndex = (): number => {
  return useRMSelector((state) => state?.layer.layerDesignSelectedTabIndex);
};
